<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-8">
                <div class="form-group">
                    <label for="description">Description</label>
                    <input id="description" type="text" class="form-control" [(ngModel)]="target.description" name="description" />
                </div>
            </div>
            <div class="col-4">
                <div class="form-group">
                    <label for="requestedById">Requested By</label>
                    <wj-combo-box
                        [(ngModel)]="target.requestedById"
                        name="requestedById"
                        [itemsSource]="userList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="fromJob">From Job</label>
                    <wj-combo-box
                        [(ngModel)]="target.fromJob"
                        name="fromJob"
                        [isRequired]="true"
                        [itemsSource]="jobList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>

            <div class="col-6">
                <div class="form-group">
                    <label for="toJob">To Job</label>
                    <wj-combo-box
                        [(ngModel)]="target.toJob"
                        name="toJob"
                        [isRequired]="true"
                        [itemsSource]="jobList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-4">
                <div class="form-group">
                    <label for="priority">Priority</label>
                    <wj-combo-box
                        [(ngModel)]="target.priority"
                        name="priority"
                        [isRequired]="true"
                        [itemsSource]="priorityList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group">
                    <label for="dueDate">Due Date</label>
                    <wj-input-date [(ngModel)]="target.dueDate" name="dueDate" [isRequired]="false"></wj-input-date>
                </div>
            </div>

            <div class="col-4">
                <div class="form-group">
                    <label for="completionDate">Completed Date</label>
                    <wj-input-date [(ngModel)]="target.completionDate" name="completionDate" [isRequired]="false"></wj-input-date>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
